export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const MOVIE_POSTER_BASE_URL = import.meta.env.VITE_MOVIE_POSTER_BASE_URL;

export const API_KEY = import.meta.env.VITE_API_KEY;

export const MOVIE_SEARCH_ENDPOINT = import.meta.env.VITE_MOVIE_SEARCH_ENDPOINT;
export const CURRENT_MOVIES_ENDPOINT = import.meta.env
  .VITE_CURRENT_MOVIES_ENDPOINT;
export const GENRE_ENDPOINT = import.meta.env.VITE_GENRE_ENDPOINT;
export const MOVIE_SEARCH_ALL_ENDPOINT = import.meta.env
  .VITE_MOVIE_SEARCH_ALL_ENDPOINT;
